/**
 * AP-40 7.5 — **Dashboard der Artikel**, die Startseite des Hauptmenüpunkts
 * (`/articles/dashboard`). Jede Kachel ist ein Filter der Artikelliste (MD-35).
 */
import { Link } from 'react-router-dom'
import { Boxes } from 'lucide-react'
import { DashboardKopf, DashboardListe, Kachel, KachelRaster, useDashboard } from '@/components/dashboard'
import { fmtDate } from '@/lib/format-date'
import { pageWide } from '@/lib/form-styles'
import { articlesApi } from '../api/articles.api'

interface Zuletzt {
  id: string
  articleNumber: string
  name: string
  updatedAt: string
  created: boolean
}

export default function ArticleDashboardPage() {
  const { daten, fehler, kachel } = useDashboard('articles', () => articlesApi.dashboard())

  return (
    <div className={pageWide}>
      <DashboardKopf
        symbol={Boxes}
        titel="Artikel"
        untertitel="Was im Stamm fehlt oder veraltet ist."
        bereich="all"
        onBereich={() => undefined}
        umschalter={false}
        stand={daten?.stand}
      />

      {fehler && <div className="text-sm text-destructive">{fehler}</div>}

      <KachelRaster>
        <Kachel titel="Artikel aktiv" kachel={kachel('active')} />
        <Kachel titel="Ohne Einkaufspreis" ton="warnung" kachel={kachel('noPrice')} hinweis="Einkaufsartikel, Vorzugslieferant ohne Preis" />
        <Kachel titel="Preis älter als 12 Monate" ton="warnung" kachel={kachel('oldPrice')} hinweis="beim Vorzugslieferanten" />
        <Kachel titel="Ohne Lieferant" ton="warnung" kachel={kachel('noSupplier')} hinweis="Einkaufsartikel ohne Lieferant" />
        <Kachel titel="Zuletzt geändert" kachel={kachel('changedRecently')} hinweis="in den letzten 7 Tagen" />
      </KachelRaster>

      <DashboardListe<Zuletzt>
        titel="Zuletzt angelegt oder geändert"
        zeilen={daten?.lists?.recent as Zuletzt[] | undefined}
        schluessel={(z) => z.id}
        alle="/articles"
        leer="Noch keine Artikel."
        zeile={(z) => (
          <>
            <span className="w-20 shrink-0 text-xs text-muted-foreground">{fmtDate(z.updatedAt)}</span>
            <Link to={`/articles/${z.id}`} className="min-w-0 flex-1 truncate hover:underline">
              <span className="mr-2 font-mono text-xs text-muted-foreground">{z.articleNumber}</span>
              {z.name}
            </Link>
            <span className="shrink-0 text-xs text-muted-foreground">{z.created ? 'neu' : 'geändert'}</span>
          </>
        )}
      />
    </div>
  )
}
